export function generateTableResultChartPointsOfInterestSeries(data, name, pointFormat = null) {
  return {
    name: name,
    color: "var(--kdiagram-speed-range-color)",
    type: "scatter",
    zIndex: 50,
    data: data,
    marker: {
      enabled: true,
      symbol: "circle",
      radius: 2,
    },

    animation: false,
    states: {
      hover: {
        enabled: false,
      },
      normal: {
        animation: false,
      },
      inactive: {
        opacity: 1,
      },
    },
    tooltip: {
      pointFormat: pointFormat
    },
  };
}
